var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "v-application v-application--is-ltr",
        id: "contractor_favorite_form",
        "max-width": "580px",
        fullscreen: !_vm.$vuetify.breakpoint.mdAndUp,
      },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _vm._v("\n            " + _vm._s(_vm.title) + "\n        "),
          ]),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("v-autocomplete", {
                staticClass: "mt-4",
                attrs: {
                  items: _vm.activePharmacists,
                  "menu-props": { closeOnContentClick: true },
                  label: "Benutzer",
                  id: "select-pharmacists",
                  multiple: "",
                  chips: "",
                  dense: "",
                },
                model: {
                  value: _vm.selectedPharmacistIds,
                  callback: function ($$v) {
                    _vm.selectedPharmacistIds = $$v
                  },
                  expression: "selectedPharmacistIds",
                },
              }),
              _vm._v(" "),
              _c(
                "v-list",
                [
                  _vm._l(_vm.savedPharmacists, function (pharmacist) {
                    return _c(
                      "v-list-item",
                      {
                        key: pharmacist._id,
                        attrs: { "data-id": pharmacist._id },
                      },
                      [
                        _c(
                          "v-list-item-content",
                          { staticStyle: { flex: "none" } },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: `/pharmacists/${pharmacist._id}`,
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(pharmacist.lastname) +
                                    ", " +
                                    _vm._s(pharmacist.firstname) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-item-action",
                          { staticClass: "ml-auto" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "", outlined: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.remove(pharmacist._id)
                                  },
                                },
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("mdi-close"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c("v-divider"),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "justify-end" },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    id: "save-pharmacists",
                    color: "success",
                    depressed: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("save", _vm.selectedPharmacistIds)
                    },
                  },
                },
                [_vm._v("\n                Speichern\n            ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { outlined: "" },
                  on: {
                    click: function ($event) {
                      _vm.isOpen = false
                    },
                  },
                },
                [_vm._v("Abbrechen")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }